import _ from 'lodash';
import moment from 'moment';

class CommissionsSummaryCtrl {

    static get $inject() {
        return ['$q', 'ModalService', '$scope', '$filter', 'PolicyService', 'UserService', '$stateParams', '$state'];
    }

    constructor($q, ModalService, $scope, $filter, PolicyService, UserService, $stateParams, $state) {

        this.PolicyService = PolicyService;
        this.UserService = UserService;
        this.$scope = $scope;
        this.$state = $state;
        this.ModalService = ModalService;
        this.errorRetrieveData = false;
        this.error = this.error.bind(this);
        this.isNegative = (value) => value.amount < 0;

        const updateCurrentPeriodDescription = () => {
            const current = this.policyPeriods.find((period) => period.isInForce);
            if (current) {
                current.description += $filter('translate')('gateway.directives.PolicyCommissionsSummaryDirective. (Current)');
                this.currentPolicyPeriod = current;
            }
        };

        const defaultToRelevantPeriod = (now) => {
            const lastIndex = this.policyPeriods.length - 1;
            if (now.isAfter(moment(this.policyPeriods[lastIndex].expirationDate))) {
                // If all periods are in the past, default to most recent (last in array)
                return this.policyPeriods[lastIndex];
            }

            // Else, all policies are in the future, default to soonest (first in array)
            return this.policyPeriods[0];
        };

        this.$onInit = () => {
            this.policyNumber = $stateParams.policyNumber;
            this.termNumber = $stateParams.termNumber;
            const now = moment();
            PolicyService.getPolicyPeriods(this.policyNumber).then((policyPeriods) => {
                this.policyPeriods = policyPeriods;
                updateCurrentPeriodDescription();
                if (!this.currentPolicyPeriod) {
                    this.currentPolicyPeriod = defaultToRelevantPeriod(now);
                }
                this.updateSummaryAndTransactions();
            }, this.error);
        };
    }

    error(err) {
        if (err && err.baseError.error.data.appErrorCode === 603) {
            this.noPolicyFound = true;
        } else if (!this.errorRetrieveData) {
            this.errorRetrieveData = true;
            this.ModalService.showError('gateway.views.modal.Error', 'gateway.directives.PolicyCommissionsSummaryDirective.Failed to retrieve the data');
        }
    }

    updateSummaryAndTransactions() {
        const termNumber = this.currentPolicyPeriod.termNumber;
        this.updateTransactions(termNumber);
        this.updateSummary(termNumber);
    }

    updateTransactions(termNumber) {
        const calculateTotalTransactions = (transactions) => {
            if (!transactions || transactions.length === 0) {
                return null;
            }
            const total = transactions.reduce((a, b) => a + b.amount.amount, 0);
            return {...transactions[0].amount, amount: total};
        };

        this.PolicyService.getCommissionsTransactionsByPolicyPeriod(this.policyNumber, termNumber).then((transactions) => {
            this.transactions = transactions;
            this.totalTransactions = calculateTotalTransactions(transactions);
        }, this.error);
    }

    updateSummary(termNumber) {
        const updateSummaryEmptyProducers = (summary) => {
            const castEmptyObjectToNull = (producer) => {
                return _.isEmpty(producer) ? null : producer;
            };
            summary.primaryProducer = castEmptyObjectToNull(summary.primaryProducer);
            summary.secondaryProducer = castEmptyObjectToNull(summary.secondaryProducer);
            summary.referrerProducer = castEmptyObjectToNull(summary.referrerProducer);
            return summary;
        };

        this.UserService.getAvailableProducerCodesForCurrentUser().then((result) => {
            const userProducerCodes = result.map((producerCode) => producerCode.code);
            
            this.PolicyService.getPolicyCommissionSummary(this.policyNumber, termNumber, userProducerCodes).then((summary) => {
                this.chartData = [{value: summary.paid.amount}, {value: summary.notPaid.amount}];
                this.haveCommission = summary.totalCommission && summary.totalCommission.amount !== 0;
                this.summary = updateSummaryEmptyProducers(summary);
            }, this.error);
            this.PolicyService.getPolicyPeriodJobType(this.policyNumber, termNumber).then((jobType) => {
                this.jobType = jobType;
            }, this.error);
        });
    }

    goToAccountCommission() {
        this.$state.go('accounts.detail.commissions', {accountNumber: this.$scope.$parent.policy.account.accountNumber});
    }

}

export default CommissionsSummaryCtrl;
